export default "__VITE_ASSET__DlSzXgwk__"